import { createClient } from '@supabase/supabase-js';

// Sales app tables live in the `sales` schema inside the Inventory Supabase
// project (same project as marketing/public; see README). PostgREST must
// expose the `sales` schema — Supabase dashboard → Settings → API →
// "Exposed schemas" must include `sales`.
//
// Reads are RLS-gated: admin/sales see everything, outlet_manager is scoped to
// their outlet's radius. Writes go through the BFF/edge functions (service
// role), never from here.
const url = import.meta.env.VITE_SUPABASE_MARKETING_URL;
const key = import.meta.env.VITE_SUPABASE_MARKETING_ANON_KEY;

if (!url || !key) {
  console.warn('[supabase/sales] missing env — sales module will show empty state');
}

export const sales = createClient(url ?? 'http://localhost', key ?? 'anon', {
  auth: { persistSession: true, autoRefreshToken: true },
  db: { schema: 'sales' },
  global: { headers: { 'x-flax-client': 'sales-app' } },
});
